import { render } from "./tabLinks.vue?vue&type=template&id=937d162e&scoped=true&ts=true"
import script from "./tabLinks.vue?vue&type=script&lang=ts"
export * from "./tabLinks.vue?vue&type=script&lang=ts"

import "./tabLinks.vue?vue&type=style&index=0&id=937d162e&scoped=true&lang=css"

import exportComponent from "/Users/mwint/Documents/Github/app-vybroo-net/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-937d162e"]])

export default __exports__